module.exports = __webpack_public_path__ + "img/data-file-bars-alternate.1e2529b8.svg";